import * as  types from './types';

export const setItem = (key, value) => {
    return {
        type: types.SET_ITEM, payload: {
            key,
            value
        }
    }
}

export const removeItem = (key) => {
    return {
        type: types.REMOVE_ITEM, payload: key
    }
}